import React from "react";
import CamperMoreInfo from "../../component/CamperMoreInfo/CamperMoreInfo";
import { camperDetailsFordRoller298 } from "../../constants/constantsCampers";
const CarCardFordRoller298 = () => {
  return <CamperMoreInfo props={camperDetailsFordRoller298}></CamperMoreInfo>;
};

export default CarCardFordRoller298;
